import { DomainInfo } from '_backend/integration/domain-info';
import { SupportedLangs } from '_public/static/domainInfo/types';

import type { FooterProps } from './Footer';
import { getDomainItems } from './utils';

export const DomainsLinks = (props: FooterProps) => {
  const { navigationData, t } = props;
  const { origin } = navigationData;
  const domainInfo = DomainInfo.getFromOrigin(origin);

  return (
    <ul
      data-testid="footer-domains-links"
      className="m-0 mt-4 flex list-none flex-wrap gap-x-3 gap-y-1 p-0 text-sm lg:mt-0">
      {getDomainItems(navigationData, domainInfo, t).map((item) => (
        <li key={item.url}>
          <a href={item.url} className="text-secondary-500 hover:text-secondary-700">
            {item.label} ({item.locales[item.domainInfoLocale as SupportedLangs]?.language})
          </a>
        </li>
      ))}
    </ul>
  );
};
